import { useContext, useLayoutEffect, useState } from 'react';
import { Grid, Box } from '@mui/material';

import globalStyles from '../../../assets/styles/global.module.scss';
import styles from '../../../assets/styles/componentStyles/templateLibraryStyles/templateLibrary.module.scss';

import TemplateFilters from './TemplateFilters';
import TemplateCards from './TemplateCards';

import { createWhatsappTemplatePayloadForTemplateLibrary, getWhatsappTemplateTypeResponse } from '../../../models/axiosModel';
import { getInitialWhatsappTemplateObject } from '../channels/global/whatsapp/whatsAppIntegrationConstant';
import TemplateLibraryHeader from './TemplateLibraryHeader';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import { useTemplateLibraryStore } from '../../../store/templateLibraryStore';
import { useCarouselFunctions } from './utils/useCarouselFunctions';

function TemplateLibrary() {

    const { isMobileScreen } = useCarouselFunctions();

    const innerHeight = isMobileScreen ? (window.innerHeight - 160) : (window.innerHeight - 120);

    const { getMetaIntegrationList, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);

    const [whatsappTemplateTypes, setWhatsappTemplateTypes] = useState<getWhatsappTemplateTypeResponse[] | null>(null);
    const [existingTemplateData, setExistingPayloadData] = useState<createWhatsappTemplatePayloadForTemplateLibrary | null>(null);

    useLayoutEffect(() => {
        if (whatsappTemplateTypes && whatsappTemplateTypes.length > 0) {
            setExistingPayloadData(
                getInitialWhatsappTemplateObject(whatsappTemplateTypes, true, templateLibraryCategoryList ?? []) as createWhatsappTemplatePayloadForTemplateLibrary
            );
        }
    }, [whatsappTemplateTypes, templateLibraryCategoryList]);

    useLayoutEffect(() => {
        (async () => {
            if (!integrationListNewStructure) {
                await getMetaIntegrationList(true);
            }
        })();
    }, [integrationListNewStructure]);

    return (
        <Grid container display={"flex"} className={`${styles.templateLibrary}`}>
            
            <Grid item xs={12} position="sticky" top={0} zIndex={100}>
                <TemplateLibraryHeader />
            </Grid>

            <Grid item xs={12} className={`${styles.templateLibrary__scrollArea} ${globalStyles.fullwidth}`}
                sx={{ maxHeight: `${innerHeight}px !important`, minHeight: `${innerHeight}px !important`, height: `${innerHeight}px !important` }}
            >
                <Box className={`${styles.templateLibrary__horizontalFilters} ${globalStyles.fullwidth}`}>
                    <TemplateFilters />
                </Box>

                <Grid container className={`${styles.templateLibrary__cards} ${globalStyles.fullwidth}`}>
                    <TemplateCards />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TemplateLibrary;
